export default __webpack_public_path__ + "assets/file_big.png";